export var REGION_BLOCKED_TITLE = 'Oh no, this subscription is not available in your region!';
export var REGION_BLOCKED_TEXT = 'Would you like to try the same great features and check out a subscription on our other offering, Cite This For Me?';
export var TEST_IDS = {
  NO_THANKS_BUTTON: 'no-thanks-button',
  SURE_BUTTON: 'sure-button'
};
export var DEFAULT_FONT_STACK = '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
export var ARIA_LABELS = {
  NO_THANKS: 'No thanks',
  SURE: 'Sure'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/components/BlockedRegionContent/constants.js
// module id = 1244
// module chunks = 11